import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import { useProjects } from "../../hooks/usePortfolioData";

function Projects() {
  const { projects, loading, error } = useProjects();

  if (loading) {
    return (
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <div className="text-center" style={{ color: "white", padding: "50px" }}>
            Loading projects...
          </div>
        </Container>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <div className="text-center" style={{ color: "white", padding: "50px" }}>
            {error}
          </div>
        </Container>
      </Container>
    );
  }

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects && projects.length > 0 ? (
            projects.map((project) => (
              <Col md={4} className="project-card" key={project.id}>
                <ProjectCard
                  imgPath={project.img_path}
                  isBlog={false}
                  title={project.title}
                  description={project.description}
                  ghLink={project.gh_link}
                  demoLink={project.demo_link}
                />
              </Col>
            ))
          ) : (
            <Col className="text-center" style={{ color: "white", padding: "50px" }}>
              No projects available at the moment.
            </Col>
          )}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
